import { DistributionChannel, ShippingPartner } from "@deliverr/replenishment-client";
import { WholesaleShippingMethod } from "@deliverr/wholesale-client";

export const getReplenishmentShippingPartnerFromDistributionChannel = (
  wholesaleShippingMethod: WholesaleShippingMethod,
  distributionChannel?: DistributionChannel
): ShippingPartner => {
  if (wholesaleShippingMethod === WholesaleShippingMethod.DELIVERR) {
    return ShippingPartner.DELIVERR;
  } else if (wholesaleShippingMethod === WholesaleShippingMethod.COLLECT) {
    return ShippingPartner.COLLECT;
  } else {
    switch (distributionChannel) {
      case DistributionChannel.WFS:
        return ShippingPartner.WFS;
      case DistributionChannel.FBA_MANUAL:
        return ShippingPartner.SELLER;
      case DistributionChannel.ECOM_VIA_CROSSDOCK:
      case DistributionChannel.ECOM_DIRECT_TO_FC:
      case DistributionChannel.ECOM_VIA_HUB:
        return ShippingPartner.DELIVERR;
      case DistributionChannel.WHOLESALE:
        return ShippingPartner.SELLER;
      default:
        return ShippingPartner.FBA;
    }
  }
};
